import type { SvgIconProps } from "@mui/material";
import { SvgIcon } from "@mui/material";

const FolderSymbolIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 -960 960 960" {...props}>
    <path d="M168-192q-29 0-50.5-21.5T96-264v-432q0-29.7 21.5-50.85Q139-768 168-768h185.64q14.35 0 27.36 5 13 5 24 16l75 75h312q29.7 0 50.85 21.15Q864-629.7 864-600v336q0 29-21.15 50.5T792-192H168Zm0-72h624v-336H450l-96-96H168v432Zm0 0v-432 432Z" />
  </SvgIcon>
);

export default FolderSymbolIcon;
